import { render, staticRenderFns } from "./RequestBody.vue?vue&type=template&id=2ebf72f8&scoped=true&"
import script from "./RequestBody.vue?vue&type=script&lang=js&"
export * from "./RequestBody.vue?vue&type=script&lang=js&"
import style0 from "./RequestBody.vue?vue&type=style&index=0&id=2ebf72f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebf72f8",
  null
  
)

export default component.exports